module.exports = "dist/3b813c2ae0d04909a33a18d792912ee7.woff";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/fonts/roboto/Roboto-Light.woff
// module id = 209
// module chunks = 0